import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/creators/{creatorId}/creditors']['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const createCreatorCreditor = async ({ creatorId, ...body }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/creators/{creatorId}/creditors', { creatorId });
  const data = await noodleApiClient.post(path, body);
  return data.data;
};

export default createCreatorCreditor;
